<template>
  <div style="padding: 0 2.5%; border: 1px solid #ddd; margin-bottom: 20px;">
    <el-row type="flex" justify="space-between" style="padding: 10px 0">
      <el-col><span>履约信息</span></el-col>
      <el-col style="display: flex; justify-content: flex-end;">
        <el-button size="small" @click="handleViewLog">查看日志</el-button>
        <el-button type="primary" size="small" @click="handleEdit"
          >编辑</el-button
        >
      </el-col>
    </el-row>
    <el-row
      :gutter="20"
      type="flex"
      style="display: flex; flex-direction: row; flex-wrap: wrap;"
    >
      <el-col
        v-for="(item, index) in formData.list"
        :key="index"
        :span="6"
        :xs="24"
        :sm="24"
        :md="8"
        :lg="6"
        :xl="6"
      >
        <el-card>
          <el-tooltip
            slot="header"
            :content="item.block_desc"
            :disabled="!item.block_desc"
            placement="top"
          >
            <div style="text-align: center;">
              <i v-if="item.block_desc" class="el-icon-info"></i
              >{{ item.block_name }}
            </div>
          </el-tooltip>
          <div
            v-for="(v, i) in item.custom_fields"
            :key="`field${i}`"
            style="display: flex; flex-direction: row; align-items: flex-start; color: gray; padding-bottom: 10px; line-height: 22px"
          >
            <el-tooltip
              slot="label"
              :content="v.field_desc"
              :disabled="!v.field_desc"
              placement="top"
            >
              <div>
                <i v-if="v.field_desc" class="el-icon-info"></i
                >{{ v.field_name }}：
              </div>
            </el-tooltip>
            <span style="display: flex; flex: 1;">
              {{ v._text }}
            </span>
          </div>
        </el-card>
      </el-col>
    </el-row>
    <!-- 日志弹窗 -->
    <el-dialog :visible.sync="isShowModalLog" title="操作日志">
      <ys-data-table
        v-model="refresh"
        :init-params="{ supply_id: supplyId }"
        :fetch-method="fetchMethod"
        :columns="columns"
        :page-size="10"
        page-size-alias="size"
      >
        <template slot="content" slot-scope="{ row }">
          <p v-for="(item, index) in row.content" :key="index">{{ item }}</p>
        </template>
      </ys-data-table>
    </el-dialog>
    <!-- 编辑弹窗 -->
    <el-dialog
      :visible.sync="isShowModalEdit"
      :close-on-click-modal="false"
      :show-close="!isLoading"
      title="编辑履约信息"
      width="80%"
    >
      <el-form ref="formData" :model="formData" size="small">
        <el-row
          :gutter="20"
          style="display: flex; flex-direction: row; flex-wrap: wrap;"
        >
          <el-col
            v-for="(item, index) in formData.list"
            :key="index"
            :span="8"
            :xs="24"
            :sm="24"
            :md="12"
            :lg="8"
            :xl="8"
          >
            <el-card>
              <el-tooltip
                slot="header"
                :content="item.block_desc"
                :disabled="!item.block_desc"
                placement="top"
              >
                <div style="text-align: center;">
                  <i v-if="item.block_desc" class="el-icon-info"></i
                  >{{ item.block_name }}
                </div>
              </el-tooltip>
              <el-form-item
                v-for="(v, i) in item.custom_fields"
                :key="`field${i}`"
                :rules="v._rules"
                :prop="`list.${index}.custom_fields.${i}._value`"
                label-width="140px"
              >
                <el-tooltip
                  slot="label"
                  :content="v.field_desc"
                  :disabled="!v.field_desc"
                  append-to-body
                  placement="top"
                >
                  <span>
                    <i v-if="v.field_desc" class="el-icon-info"></i
                    >{{ v.field_name }}：
                  </span>
                </el-tooltip>
                <el-row
                  v-if="v.field_type === constEnum.INPUT"
                  type="flex"
                  style="color: gray;"
                >
                  <ys-input
                    v-model="v._value"
                    type="textarea"
                    autosize
                  ></ys-input>
                </el-row>
                <el-row
                  v-else-if="v.field_type === constEnum.SELECT"
                  type="flex"
                  style="color: gray;"
                >
                  <el-select v-model="v._value">
                    <el-option
                      v-for="(option, ii) in v.option_values"
                      :key="`option${ii}`"
                      :label="option"
                      :value="option"
                    ></el-option>
                  </el-select>
                </el-row>
                <el-row
                  v-else-if="v.field_type === constEnum.DATE"
                  type="flex"
                  style="color: gray;"
                >
                  <el-time-picker
                    v-if="v.option_type === constEnum.IS_TIME"
                    v-model="v._value"
                    value-format="HH:mm:ss"
                  ></el-time-picker>
                  <el-time-picker
                    v-else-if="v.option_type === constEnum.IS_TIME_RANGE"
                    v-model="v._value"
                    is-range
                    range-separator="至"
                    start-placeholder="开始时间"
                    end-placeholder="结束时间"
                    placeholder="选择时间范围"
                    value-format="HH:mm:ss"
                  >
                  </el-time-picker>
                  <el-date-picker
                    v-else-if="v.option_type === constEnum.IS_DATE"
                    v-model="v._value"
                    type="time"
                    placeholder="选择日期"
                    format="yyyy-MM-dd"
                  ></el-date-picker>
                  <el-date-picker
                    v-else-if="v.option_type === constEnum.IS_DATE_RANGE"
                    v-model="v._value"
                    type="daterange"
                    is-range
                    range-separator="至"
                    start-placeholder="开始时间"
                    end-placeholder="结束时间"
                  ></el-date-picker>
                  <el-date-picker
                    v-else-if="v.option_type === constEnum.IS_DATE_TIME"
                    v-model="v._value"
                    type="datetime"
                    placeholder="选择日期时间"
                    value-format="yyyy-MM-dd HH:mm:ss"
                  ></el-date-picker>
                  <el-date-picker
                    v-else-if="v.option_type === constEnum.IS_DATE_TIME_RANGE"
                    v-model="v._value"
                    type="datetimerange"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    value-format="yyyy-MM-dd HH:mm:ss"
                  >
                  </el-date-picker>
                </el-row>
              </el-form-item>
            </el-card>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer">
        <el-button
          :loading="isLoading"
          size="small"
          @click="isShowModalEdit = false"
          >关闭</el-button
        >
        <el-button
          :loading="isLoading"
          type="danger"
          size="small"
          plain
          @click="handleFormatFormData"
          >重置</el-button
        >
        <el-button
          :loading="isLoading"
          type="primary"
          size="small"
          @click="handleConfirm"
          >保存</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>
<script>
import * as dayjs from "dayjs";
import {
  getSupplyFulfillDetail,
  getSupplyFulfillLog,
  saveSupplyFulfillDetail,
} from "@/api/supply";

const constEnum = {
  INPUT: 1,
  SELECT: 2,
  DATE: 3,
  IS_TIME: 1,
  IS_TIME_RANGE: 2,
  IS_DATE: 3,
  IS_DATE_RANGE: 4,
  IS_DATE_TIME: 5,
  IS_DATE_TIME_RANGE: 6,
};
const noop = () => {};
const validDate = (rule, value, callback) => {
  if (value.some(item => !item)) {
    callback(new Error("必选"));
  } else {
    callback();
  }
};
export default {
  name: "SupplyFulfillDetail",
  props: {
    supplyId: {
      type: [Number, String],
      default: "",
    },
  },
  data() {
    return {
      constEnum: constEnum,
      isShowModalLog: false,
      isShowModalEdit: false,
      list: [], // 接口数据
      formData: {
        list: [],
      },
      isLoading: false,
      refresh: false,
      fetchMethod: getSupplyFulfillLog,
      columns: [
        { label: "事件", prop: "event" },
        { label: "内容", slot: "content" },
        { label: "操作人", prop: "operator" },
        { label: "操作时间", prop: "created" },
      ],
    };
  },
  methods: {
    handleGetInfo() {
      getSupplyFulfillDetail({ supply_id: this.supplyId })
        .then(res => {
          const { code, data, msg } = res.data;
          if (String(code) === "200") {
            this.list = data;
            this.handleFormatFormData();
          } else {
            this.$message.error(msg);
          }
        })
        .catch(noop);
    },
    handleFormatFormData() {
      const list = this.list;
      const formatList = list.map(item => {
        const { custom_fields, ...rest } = item;
        const customFields = item.custom_fields.map(v => {
          const { field_type, field_require, field_values, option_type } = v;
          const {
            field_value,
            time_start,
            time_end,
            date_start,
            date_end,
          } = field_values;
          // 针对不同 field_type 生成对应不同组件类型的校验规则
          const rulesMap = {
            1: { required: true, message: "必填", trigger: "blur" },
            2: { required: true, message: "必选", trigger: "change" },
          };
          // 针对不同 option_type 生成对应组件的数据
          // value：(表单值)，text：(用于页面展示)，rules：(表单值校验规则) defaultRules: (表单值默认校验规则，主要用于输入类型)
          const valueMap = {
            0: () => {
              return {
                value: field_value,
                text: field_value,
                rules: { required: true, message: "必选", trigger: "change" },
              };
            },
            1: () => {
              return {
                value: time_start,
                text: time_start,
                rules: { required: true, message: "必选", trigger: "change" },
              };
            },
            2: () => {
              return {
                value: [time_start, time_end],
                text: time_start && time_end ? `${time_start}-${time_end}` : "",
                rules: {
                  required: true,
                  validator: validDate,
                  trigger: "change",
                  type: "array",
                },
                defaultRules: {
                  type: "array",
                },
              };
            },
            3: () => {
              return {
                value: date_start,
                text: date_start,
                rules: {
                  required: true,
                  message: "必选",
                  trigger: "change",
                },
              };
            },
            4: () => {
              return {
                value: [date_start, date_end],
                text: date_start ? `${date_start} ~ ${date_end}` : "",
                rules: {
                  required: true,
                  validator: validDate,
                  trigger: "change",
                  type: "array",
                },
                defaultRules: {
                  type: "array",
                },
              };
            },
            5: () => {
              return {
                value: date_start ? `${date_start} ${time_start}` : "",
                text: date_start ? `${date_start} ${time_start}` : "",
                rules: {
                  required: true,
                  message: "必选",
                  trigger: "change",
                },
              };
            },
            6: () => {
              return {
                value: [
                  date_start ? `${date_start} ${time_start}` : "",
                  date_end ? `${date_end} ${time_end}` : "",
                ],
                text:
                  date_start && date_end
                    ? `${date_start} ${time_start} ~ ${date_end} ${time_end}`
                    : "",
                rules: {
                  required: true,
                  validator: validDate,
                  trigger: "change",
                  type: "array",
                },
                defaultRules: {
                  type: "array",
                },
              };
            },
          };
          const { value, text, rules, defaultRules } = valueMap[option_type]();
          return {
            ...v,
            _rules:
              field_require === 1
                ? rulesMap[field_type] || rules
                : defaultRules || {},
            _value: value,
            _text: text,
          };
        });
        return {
          custom_fields: customFields,
          ...rest,
        };
      });
      this.formData = {
        list: formatList,
      };
    },
    handleViewLog() {
      this.isShowModalLog = true;
      this.refresh = true;
    },
    handleEdit() {
      this.isShowModalEdit = true;
    },
    handleTransformParams() {
      const { supplyId, formData } = this;
      const { list } = formData;
      const formatList = list.map(item => {
        const { custom_fields, ...rest } = item;
        const customFields = custom_fields.map(v => {
          const {
            _value,
            _text,
            _rules,
            field_values,
            option_type,
            ...last
          } = v;
          // 针对 option_type 把表单对应的值转译为接口中对应的字段
          const valuesMap = {
            0: () => {
              return {
                field_value: _value,
              };
            },
            1: () => {
              return {
                time_start: _value,
              };
            },
            2: () => {
              const [time_start, time_end] = _value;
              return {
                time_start,
                time_end,
              };
            },
            3: () => {
              return {
                date_start: dayjs(_value).format("YYYY-MM-DD"),
              };
            },
            4: () => {
              const [date_start, date_end] = _value.map(item =>
                dayjs(item).format("YYYY-MM-DD"),
              );
              return {
                date_start,
                date_end,
              };
            },
            5: () => {
              return {
                date_start: dayjs(_value).format("YYYY-MM-DD"),
                time_start: dayjs(_value).format("HH:mm:ss"),
              };
            },
            6: () => {
              const [start, end] = _value;
              return {
                date_start: dayjs(start).format("YYYY-MM-DD"),
                time_start: dayjs(start).format("HH:mm:ss"),
                date_end: dayjs(end).format("YYYY-MM-DD"),
                time_end: dayjs(end).format("HH:mm:ss"),
              };
            },
          };
          return {
            ...last,
            option_type,
            field_values: valuesMap[option_type](),
          };
        });
        return {
          ...rest,
          custom_fields: customFields,
        };
      });
      return {
        supply_id: supplyId,
        perform_data: formatList,
      };
    },
    handleConfirm() {
      if (this.isLoading) {
        return;
      }
      this.$refs.formData.validate(valid => {
        if (valid) {
          this.isLoading = true;
          const params = this.handleTransformParams();
          saveSupplyFulfillDetail(params)
            .then(res => {
              const { code, msg } = res.data;
              if (String(code) === "200") {
                this.$message.success("编辑成功");
                this.isShowModalEdit = false;
                this.handleGetInfo();
              } else {
                this.$message.error(msg);
              }
            })
            .catch(noop)
            .finally(() => {
              this.isLoading = false;
            });
        }
      });
    },
  },
  watch: {
    supplyId: {
      handler(val) {
        val && this.handleGetInfo();
      },
      immediate: true,
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/supply/components/SupplyFulfillDetail.vue